import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

// Views
import Start from '../views/Start.vue'
import Services from '../views/Services.vue'
import IdeaVision from '../views/Idea-Vision.vue'
import Contact from '../views/Contact.vue'
import PrivacyPolicy from '../views/PrivacyPolicy.vue'

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'Start',
        component: Start,
    },
    {
        path: '/services',
        name: 'Services',
        component: Services,
    },
    {
        path: '/idea-vision',
        name: 'IdeaVision',
        component: IdeaVision,
    },
    {
        path: '/contact',
        name: 'Contact',
        component: Contact,
    },
    {
        path: '/privacy-policy',
        name: 'PrivacyPolicy',
        component: PrivacyPolicy,
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior() {
        return { top: 0 }
    },
})

export default router
